// NATIONAL INDICATORS
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import SectionWithArrows from 'components/organisms/SectionWithArrows/SectionWithArrows';
import { StatisticsService } from 'services';

import { NationalIndicatorsContext } from './contexts';
import {
    ChartFive,
    ChartFour,
    ChartOne,
    ChartSix,
    ChartTen,
    ChartThree,
    ChartTwo,
    ChartSeven,
    ChartNine,
    ChartEleven,
    ChartEight, ChartTwelve, ChartThirteen, ChartFourteen, ChartFifteen,
} from './components';
import clsx from 'clsx';
import Loader from 'components/organisms/Loader';

const useStyles = makeStyles((theme) => ({
    root: {},
    content: {
        minHeight: 450,
        '& .section': {
            paddingTop: theme.spacing(4),
        },
    },
    filtersContainer: {
        marginBottom: theme.spacing(1),
    },
    chartContainer: {
        boxShadow: '0 0 4px #00000029',
        borderRadius: '10px',
        marginBottom: '20px',
        marginTop: '20px',
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
        },
    },
    rightContainer: {
        width: '250px',
    },
    leftContainer: {
        width: '75%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    divider: {
        height: 5,
        marginTop: 50,
        marginBottom: 30,
    },
    dictionary: {
        boxShadow: '0px 3px 6px #00000029',
        borderRadius: '10px',
        backgroundColor: '#f6f6f6',
        padding: theme.spacing(4),
        marginTop: theme.spacing(6),
        width: '280px',
    },
    dictionaryTitle: {
        marginBottom: 0,
        alignSelf: 'flex-end',
    },
    dictionaryHeader: {
        display: ' flex',
        flexDirection: 'row',
        marginBottom: 20,
    },
    dictionaryTerm: {
        fontStyle: 'italic',
        fontSize: 12,
    },
    dictionaryParagraph: {
        display: 'inline',
        marginBottom: 10,
        fontSize: 12,
    },
    filterText: {
        fontSize: '18px',
        marginLeft: '12px',
        marginBottom: '10px',
    },
    title: {
        fontSize: '24px',
        fontStyle: 'Roboto-Regular',
        textAlign: 'center',
        color: '#981B49',
    },
    chartButton: {
        width: '282px',
        fontWeight: theme.typography.fontWeightBold,
        fontSize: 15,
        marginTop: theme.spacing(5),
        color: '#981B49',
        backgroundColor: 'white',
        boxShadow: '0px 3px 6px #00000029',
        '&:hover': {
            color: 'white',
            backgroundColor: 'black',
        },
    },
    chartMargin: {
        marginTop: '50px',
    },
}));

const NationalIndicators = (props) => {
    const { className} = props; // eslint-disable-line no-unused-vars
    const classes = useStyles();
    const statisticsService = new StatisticsService();

    const [chartData, setChartData] = useState([]);
    const [spinner, setSpinner] = useState(true);

    // One time only
    useEffect(() => {
        setSpinner(true);

        (async () => {
            const newData = await statisticsService.getNationalIndicatorChartData();
            setChartData(newData['data']);
            setSpinner(false);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <NationalIndicatorsContext.Provider value={{}}>
            {spinner ? (
                <Loader />
            ) : (
                <div className={clsx(classes.root, className)}>
                    <SectionWithArrows className={clsx(classes.content)} statisticsWidth={true}>
                        <div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_four']['title']}
                                </div>
                                <ChartFour data={chartData['chart_four']} name={'chartFour'}
                                           className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_thirteen']['title']}
                                </div>
                                <ChartThirteen data={chartData['chart_thirteen']} name={'chartThirteen'}
                                               className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_one']['title']}
                                </div>
                                <ChartOne data={chartData['chart_one']} name={'chartOne'}
                                          className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_fourteen']['title']}
                                </div>
                                <ChartEleven data={chartData['chart_fourteen']} name={'chartEleven'}
                                             className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_eleven']['title']}
                                </div>
                                <ChartFourteen data={chartData['chart_eleven']} name={'chartFourteen'}
                                               className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_fifteen']['title']}
                                </div>
                                <ChartFifteen data={chartData['chart_fifteen']} name={'chartFifteen'}
                                              className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_nine']['title']}
                                </div>
                                <ChartNine data={chartData['chart_nine']} name={'chartNine'}
                                           className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_two']['title']}
                                </div>
                                <ChartTwo data={chartData['chart_two']} name={'chartTwo'}
                                          className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_twelve']['title']}
                                </div>
                                <ChartTwelve data={chartData['chart_twelve']} name={'chartTwelve'}
                                             className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_three']['title']}
                                </div>
                                <ChartThree data={chartData['chart_three']} name={'chartThree'}
                                            className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_five']['title']}
                                </div>
                                <ChartFive data={chartData['chart_five']} name={'chartFive'}
                                           className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_sixteen']['title']}
                                </div>
                                <ChartEight data={chartData['chart_sixteen']} name={'chartSixteen'}
                                            className={classes.chartContainer} height='80px'/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_ten']['title']}
                                </div>
                                <ChartTen data={chartData['chart_ten']} name={'chartTen'}
                                          className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_six']['title']}
                                </div>
                                <ChartSix data={chartData['chart_six']} name={'chartSix'}
                                          className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_seven']['title']}
                                </div>
                                <ChartSeven data={chartData['chart_seven']} name={'chartSeven'}
                                            className={classes.chartContainer}/>
                            </div>
                            <div className={classes.chartMargin}>
                                <div className={clsx(classes.title)}>
                                    {chartData['chart_eight']['title']}
                                </div>
                                <ChartEight data={chartData['chart_eight']} name={'chartEight'}
                                            className={classes.chartContainer}/>
                            </div>
                        </div>
                    </SectionWithArrows>
                </div>
            )}
        </NationalIndicatorsContext.Provider>
    );
};

NationalIndicators.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default NationalIndicators;
